import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//#region Imports

import { TABLE_OVERFLOW_CHANGE_TRIGGER } from '@atlaskit/editor-common/analytics';
import { findTable, toggleHeader } from '@atlaskit/editor-tables/utils';
import { createCommand } from '../plugin-factory';
import { META_KEYS } from '../table-analytics';
//#endregion

// #region Utils
/**
 * Table layout toggle logic
 * default -> wide -> full-width -> default
 */
export var getNextLayout = function getNextLayout(currentLayout) {
  switch (currentLayout) {
    case 'default':
      return 'wide';
    case 'wide':
      return 'full-width';
    case 'full-width':
      return 'default';
    default:
      return 'default';
  }
};
// #endregion

// #region Actions
export var toggleHeaderRow = function toggleHeaderRow(state, dispatch) {
  return toggleHeader('row')(state, function (tr) {
    return createCommand({
      type: 'TOGGLE_HEADER_ROW'
    }, function () {
      return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
  });
};
export var toggleHeaderColumn = function toggleHeaderColumn(state, dispatch) {
  return toggleHeader('column')(state, function (tr) {
    return createCommand({
      type: 'TOGGLE_HEADER_COLUMN'
    }, function () {
      return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
  });
};
export var toggleNumberColumn = function toggleNumberColumn(state, dispatch) {
  var tr = state.tr;
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var _ref = findTable(state.selection),
    node = _ref.node,
    pos = _ref.pos;
  var isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
  tr.setNodeMarkup(pos, state.schema.nodes.table, _objectSpread(_objectSpread({}, node.attrs), {}, {
    isNumberColumnEnabled: !isNumberedColumnEnabled
  }));
  tr.setMeta('scrollIntoView', false);
  var tableOverflowChangeTriggerName = isNumberedColumnEnabled ? TABLE_OVERFLOW_CHANGE_TRIGGER.DISABLED_NUMBERED_COLUMN : TABLE_OVERFLOW_CHANGE_TRIGGER.ENABLED_NUMBERED_COLUMN;
  tr.setMeta(META_KEYS.OVERFLOW_TRIGGER, {
    name: tableOverflowChangeTriggerName
  });
  if (dispatch) {
    dispatch(tr);
  }
  return true;
};
export var toggleTableLayout = function toggleTableLayout(state, dispatch) {
  var table = findTable(state.selection);
  if (!table) {
    return false;
  }
  var layout = getNextLayout(table.node.attrs.layout);
  return createCommand({
    type: 'SET_TABLE_LAYOUT',
    data: {
      layout: layout
    }
  }, function (tr) {
    tr.setNodeMarkup(table.pos, state.schema.nodes.table, _objectSpread(_objectSpread({}, table.node.attrs), {}, {
      layout: layout
    }));
    tr.setMeta(META_KEYS.OVERFLOW_TRIGGER, {
      name: TABLE_OVERFLOW_CHANGE_TRIGGER.RESIZED
    });
    return tr.setMeta('scrollIntoView', false);
  })(state, dispatch);
};
export var toggleContextualMenu = function toggleContextualMenu() {
  return createCommand({
    type: 'TOGGLE_CONTEXTUAL_MENU'
  }, function (tr) {
    return tr.setMeta('addToHistory', false);
  });
};
// #endregion